





































import Vue from 'vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import { Swiper } from 'swiper'
import Carousel from '@/common/components/Carousel.vue'
import { ProductSkuImage } from '@/product/types'

export default Vue.extend({
  components: {
    ModalOverlay,
    Carousel
  },
  props: {
    imageList: {
      type: Array as () => ProductSkuImage[],
      required: true
    },
    currentActiveIndex: {
      type: Number,
      required: true
    },
    productName: {
      type: String,
      required: true
    }
  },
  data(): {
    swiper?: Swiper
  } {
    return {
      swiper: undefined
    }
  },
  mounted() {
    this.swiper = (this.$refs.prProductImagesPreview as any)?.swiper
    this.swiper?.slideToLoop(this.currentActiveIndex, 0, false)
  },
  methods: {
    closePreviewImages() {
      this.$emit('closePreviewImages', this.swiper?.realIndex)
    }
  }
})
